import LocalImage from "@/components/image/LocalImage";

//#region [Props]
type PlayButtonProps = {
    className?: string;
    alt: string;
};
//#endregion

//#region [Component]
export default function PlayButton({ className, alt }: PlayButtonProps) {
    return <LocalImage className={className} src="/Playknapp.svg" alt={alt} width={140} height={140} />;
}
//#endregion
